<div class="block">Schwab Asset Classes are included in iRebal. Your securities are automatically categorized using Schwab's classifications, giving you unparalleled insight into millions of stocks, ETFs, and mutual funds.</div>

@if (data.length > 1) {
  <div>
    <irb-inventory-grid
      [style.width] = "'100%'"
      [style.height] = "'240px'"
      [showSideBar] = "false"
      [gridOptions] = "gridOptions"
      [rowData] = 'data'
      [footerContent] = 'footerContent'
    (gridReady) = "onGridReady($event)"></irb-inventory-grid></div>
  }

  @if (data.length == 1) {
    <div style="padding: 10px; background-color: #EEE;">
      <div class="block bold">Schwab Asset Classes</div>
      <div style="display: flex; flex-flow: row; gap: 20px;">
        <div>
          <div class="hblock bold">Level 1</div>
          <div>{{data[0].acLevel1}}</div>
        </div>
        <div>
          <div class="hblock bold">Level 2</div>
          <div>{{data[0].acLevel2}}</div>
        </div>
        <div>
          <div class="hblock bold">Level 3</div>
          <div>{{data[0].acLevel3}}</div>
        </div>
        <div>
          <div class="hblock bold">Level 4</div>
          <div>{{data[0].acLevel4}}</div>
        </div>
      </div>
    </div>
  }